<template src="./index_copy.html"></template>

<script>
import { format, parseISO, startOfMonth, isEqual } from 'date-fns'
import swal from 'sweetalert2'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import $api from '@/plugins/axiosInstance.js'
import {ko} from 'vuejs-datepicker/dist/locale'

const today = new Date()
const ICONS = {
  exposure: 'fas fa-bullhorn',
  magazine: 'far fa-star',
  release_18h: 'far fa-clock',
  overseas: 'fas fa-globe-americas',
  genre_ccm: 'fas fa-church',
  overseas_complete: 'fab fa-spotify',
}
const ALBUM_TYPE_CATEGORY = {
  album: 'Album',
  ep: 'EP',
  single: 'Single',
}
import Vue from 'vue'
import {BButton, BTooltip,} from 'bootstrap-vue'
const EventClass = Vue.extend(BTooltip)

export default {
  components: {
    FullCalendar,
  },
  
  data () {
    return {
      ko : ko,
      selectMonth: new Date(),

      exposure: false,
      magazine: false,
      release18h: false,
      overseas: false,
      ccm: false,
      overseasComplete: false,
      tags_v2 : [],

      monthData: [
        {
          date:'2023-08-07',
          count_slots:7,
          count_albums:4,

          temporary : 1,
          "registration_complete":2,
          inspection_complete : 2,
          distribution_complete:2,
          release_complete :2,
        },
        {
          date:'2023-08-08',
          count_slots:7,
          count_albums:4,
          temporary : 1,
          "registration_complete":2,
          inspection_complete : 2,
          distribution_complete:2,
          release_complete :2,
        },
        {
          date:'2023-08-09',
          count_slots:7,
          count_albums:4,
          temporary : 1,
          "registration_complete":2,
          inspection_complete : 2,
          distribution_complete:2,
          release_complete :2,
        }
      ],
      weekData : [
        {
          date:'2023-08-07',
          count_slots:7,
          count_albums:4,
          albums:[
            {
              id:123,
              name: 'album123',
              artist : 'ddd',
              state : 'temporary',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
          ]
        },
        {
          date:'2023-08-08',
          count_slots:7,
          count_albums:4,
          albums:[
            {
              id:123,
              name: 'album123',
              artist : 'ddd',
              state : 'temporary',
              release_type : 'ep',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'distribution_complete',
              release_type : 'album',
              track_count : 4
            },
          ]
        },
        {
          count_slots:7,
          count_albums:4,
          date:'2023-08-09',
          albums:[
            {
              id:123,
              name: 'album123',
              artist : 'ddd',
              state : 'temporary',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'distribution_complete',
              release_type : 'album',
              
              track_count : 4
            },
          ]
        }
      ],
      dayData : [
        {
          date:'2023-08-09',
          count_slots:7,
          count_albums:4,
          albums:[
            {
              id:123,
              name: 'album123',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
            {
              id:124,
              name: 'album125',
              artist : 'ddd',
              state : 'registration_complete',
              release_type : 'album',
              track_count : 4
            },
          ]
        },
        
      ],
      baseDate: today,
      
      
      tags :[[]],
      monthType:"A",
      calendarOptions: {
        locale: 'ko',
        selectable: false,
        selectHelper: true,
        editable: false,
        initialView: 'dayGridMonth',
        initialDate: today,
        initialEvent: this.events,
        events : this.events,
        height: 'auto',//958
        //eventsSet: this.handleEvents,
        eventLimit: true,
        theme: true, 
        fixedWeekCount: false,
        plugins: [dayGridPlugin,interactionPlugin],
        
        headerToolbar: {
          left: 'prev,next,today',
          center: 'title',
          right: 'test,dayGridMonth,dayGridWeek,dayGridDay',
        },
        
        eventColor: 'transparent',
        customButtons: {
          'test': {
            text: 'Type-A',
            click: () => {
              if(this.monthType == 'A'){
                this.monthType = 'B'
                this.calendarOptions.customButtons.test.text = 'Type-B'
              }else{
                this.monthType = 'A'
                this.calendarOptions.customButtons.test.text = 'Type-A'
              }
              const calendarApi = this.$refs.fullCalendar.getApi()
              const currentStart = calendarApi.view.activeStart
              this.dateCall(this.monthData)
            },
          },
          prev: {
            text: 'PREV',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi()
              console.log(calendarApi)
              calendarApi.prev()
              const currentStart = calendarApi.view.activeStart
              this.dateCall(this.monthData)
            },
          },
          next: {
            text: 'NEXT',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi()
              calendarApi.next()
              const currentStart = calendarApi.view.activeStart
              console.log(calendarApi.view.activeStart);
              currentStart.getMonth()
              this.dateCall(this.monthData)
            },
          },
          today: {
            text: 'TODAY',
            click: () => {
              const calendarApi = this.$refs.fullCalendar.getApi()
              calendarApi.today()
              const currentStart = calendarApi.view.activeStart
              this.dateCall(this.monthData)
            },
          },
          dayGridMonth: {
            text: 'Month',
            click: () => {
              console.log('dasdas')
              const calendarApi = this.$refs.fullCalendar.getApi()
              calendarApi.changeView('dayGridMonth')
              const currentStart = calendarApi.view.activeStart
              //this.checkBaseDay(currentStart)
              calendarApi.setOption('height', 'auto');
              this.selectMonth = currentStart  
              this.dateCall(this.monthData)
            },
          },
          dayGridWeek: {
            text: 'Week',
            click: () => {
              console.log('dasdas')
              const calendarApi = this.$refs.fullCalendar.getApi()
              calendarApi.changeView('dayGridWeek')
              const currentStart = calendarApi.view.activeStart
              calendarApi.setOption('height', 700);
              //this.checkBaseDay(currentStart)
              this.selectMonth = currentStart  
              this.dateCall(this.weekData)
            },
          },
          dayGridDay: {
            text: 'Day',
            click: () => {
              console.log('dasdas')
              const calendarApi = this.$refs.fullCalendar.getApi()
              calendarApi.changeView('dayGridDay')
              const currentStart = calendarApi.view.activeStart
              // this.checkBaseDay(currentStart)
              calendarApi.setOption('height', 700);
              this.dateCall(this.dayData)
            },
          },
        },
      
      },
      popData : {},
      popSelect : null,
      popSelectOption : [
        {label : '전체',value : null},
        {label : '임시저장',value : 'temporary'},
        {label : '접수',value : 'registration_complete'},
        {label : '검수완료',value : 'inspection_complete'},
        {label : '유통완료',value : 'distribution_complete'},
        {label : '발매완료',value : 'release_complete'},
      ],
      calendarDayOptions: {
        locale: 'ko',
        plugins: [dayGridPlugin,interactionPlugin],
        theme: true,
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        selectable: false,
        selectHelper: true,
        editable: false,
        initialView: 'dayGridDay',
        initialDate: today,
        initialEvent: this.events,
        events : this.events,
        height: '100%',
        //eventsSet: this.handleEvents,
        eventLimit: true,
        
        dateClick:this.handleDateClick,
        fixedWeekCount: false,
        eventColor: 'transparent',
        customButtons: {
          prev: {
            text: 'PREV',
            click: () => {
              const calendarApi = this.$refs.fullCalendarDay.getApi()
              calendarApi.prev()
              const currentStart = calendarApi.view.activeStart
              this.monthAlertCall(currentStart)
            },
          }, 
          next: {
            text: 'NEXT',
            click: () => {
              const calendarApi = this.$refs.fullCalendarDay.getApi()
              calendarApi.next()
              const currentStart = calendarApi.view.activeStart
              console.log(calendarApi.view.activeStart);
              currentStart.getMonth()
              this.monthAlertCall(currentStart)
            },
          }, 
          today: {
            text: 'TODAY',
            click: () => {
              const calendarApi = this.$refs.fullCalendarDay.getApi()
              calendarApi.today()
              const currentStart = calendarApi.view.activeStart
              this.monthAlertCall(currentStart)
            },
          }, 
        },
        
      },
      slotData: [
        {date : '2023-07-30' ,slots: 10},
        {date : '2023-07-31' ,slots: 10},
        {date : '2023-08-01' ,slots: 10},
        {date : '2023-08-02' ,slots: 10},
        {date : '2023-08-03' ,slots: 10},
        {date : '2023-08-04' ,slots: 10},
        {date : '2023-08-05' ,slots: 10},
        {date : '2023-08-06' ,slots: 10},
        {date : '2023-08-07' ,slots: 10},
        {date : '2023-08-08' ,slots: 10},
        {date : '2023-08-09' ,slots: 10},
        {date : '2023-08-10' ,slots: 10},
        {date : '2023-08-11' ,slots: 10},
        {date : '2023-08-12' ,slots: 10},
        {date : '2023-08-13' ,slots: 10},
        {date : '2023-08-14' ,slots: 10},
        {date : '2023-08-15' ,slots: 10},
        {date : '2023-08-16' ,slots: 10},
        {date : '2023-08-17' ,slots: 10},
        {date : '2023-08-18' ,slots: 10},
        {date : '2023-08-19' ,slots: 10},
        {date : '2023-08-20' ,slots: 10},
        {date : '2023-08-21' ,slots: 10},
        {date : '2023-08-22' ,slots: 10},
        {date : '2023-08-23' ,slots: 10},
        {date : '2023-08-24' ,slots: 10},
        {date : '2023-08-25' ,slots: 10},
        {date : '2023-08-26' ,slots: 10},
        {date : '2023-08-27' ,slots: 10},
        {date : '2023-08-28' ,slots: 10},
        {date : '2023-08-29' ,slots: 10},
        {date : '2023-08-30' ,slots: 10},
        {date : '2023-08-31' ,slots: 10},
        {date : '2023-09-01' ,slots: 10},
        {date : '2023-09-02' ,slots: 10},
      ],
      slotCalendarOptions:{
        locale: 'ko',
        plugins: [dayGridPlugin,interactionPlugin],
        theme: true,
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        selectable: false,
        selectHelper: false,
        editable: false,
        initialView: 'dayGridMonth',
        initialDate: today,
        events : [],
        height: 958,
        //eventsSet: this.handleEvents,
        fixedWeekCount: false,
        eventColor: 'transparent',
        customButtons: {
          prev: {
            text: 'PREV',
            click: () => {
              const calendarApi = this.$refs.fullCalendarSlot .getApi()
              calendarApi.prev()
              this.slotCall(this.monthData)
            },
          },
          next: {
            text: 'NEXT',
            click: () => {
              const calendarApi = this.$refs.fullCalendarSlot .getApi()
              calendarApi.next()
              const currentStart = calendarApi.view.activeStart
              this.slotCall(this.monthData)
            },
          },
          
          },
      },
      slotEdit : false,
      daySlotData : {
        date:null,
        count_slots:0,
        count_albums:0,
      },
      tagList: {
        'exposure' : '※', 
        'magazine' : '★', 
        'release_time' : '☾', 
        'has_mv' : 'M', 
        'has_beat' : 'B', 
        'marketing_rec' : '♣', 
        'genre_ccm' :'✝', 
        't_only_korea' : 'K', 
        't_except_korea' :'G'
      }
    }
  }, 
  mounted(){
    this.$nextTick(()=>{
      let baseDay = format(startOfMonth(today), 'yyyy-MM-dd')
      if(this.$route.query.date){
        baseDay = this.$route.query.date
        this.baseDate = this.$route.query.date
        this.selectMonth = this.$route.query.date
        const calendarApi = this.$refs.fullCalendar.getApi()
      }
      // this.queryEvents(baseDay).then((res) => {
      // }).catch((error) => {
      //   const status = error.response.status
      //   switch(status) {
      //     case 401:this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')});break;
      //     default:console.error(error);break;
      //   }
      // })
      this.dateCall(this.monthData)
    })
  },
  methods: {
    typeText(val){
      let dd = {
          temporary :'임시저장',
          registration_complete : '접수', 
          registration_canceled : '유통 취소', 
          inspection_complete : '검수 완료', 
          distribution_complete : '유통 완료', 
          release_complete : '발매 완료', 
          suspended : '유통중단', 
          rejected : '반려',
          trash : '임시삭제'
      }
      let color = {
          temporary : "#9544d0b3",//'임시저장',
          registration_complete : '#747ca4',//'접수', 
          registration_canceled : '#797979',//'유통 취소', 
          inspection_complete : '#4092ff',//'검수 완료', 
          distribution_complete : '#ff9f43',//'유통 완료', 
          release_complete : '#24c1a0',//'발매 완료', 
          suspended : '#b8c2cc',//'유통중단', 
          rejected : '#ea5455',//'반려' 
          trash : "#737373"
      }
      if(dd.hasOwnProperty(val)){
        return `
                <div class="con-vs-chip vs-chip-primary con-color" 
                style="
                    background-color: ${color[val]} !important;
                    color:#fff;
                    line-height: 1;
                    padding: 1px 5px;
                    font-size: 11px;
                    float: none;
                    min-width: 50px;
                    display: inline-block;
                    min-height: 0;
                ">
                    <span style="margin:0" class="text-chip vs-chip--text">
                    ${dd[val]}
          </span><!----></div>`
      }else {
        return 'type'
      }
      
    },
    handleDateClick (info) {
      
    },
    handleEventClick (info) {
      this.popData = info
      
      this.openModal('calendar')
    },
    openMonthAlert(info,type = null){
      const extendedProps  = info.event.extendedProps.data
      this.popData = extendedProps
      this.popSelect = type
      console.log(type)
      this.calendarDayOptions.initialDate = info.event.startStr
      this.calendarDayOptions.events = []
      if(extendedProps.temporary){
        this.popSelectOption = [
          {label : '전체',value : null},
          {label : '임시저장 (' +extendedProps.temporary+')' ,value : 'temporary'},
          {label : '접수 (' +extendedProps.registration_complete+')',value : 'registration_complete'},
          {label : '검수완료 (' +extendedProps.inspection_complete+')',value : 'inspection_complete'},
          {label : '유통완료 (' +extendedProps.distribution_complete+')',value : 'distribution_complete'},
          {label : '발매완료 (' +extendedProps.release_complete+')',value : 'release_complete'},
        ]  
      }else{
        this.popSelectOption = [
          {label : '전체',value : null},
          {label : '임시저장' ,value : 'temporary'},
          {label : '접수 ',value : 'registration_complete'},
          {label : '검수완료',value : 'inspection_complete'},
          {label : '유통완료',value : 'distribution_complete'},
          {label : '발매완료',value : 'release_complete'},
        ]
      }
      
      this.monthAlertCall(info.event.startStr)
      this.openModal('calendarDay')
    },
    selectState(){
      this.monthAlertCall(this.calendarDayOptions.initialDate)
    },
    monthAlertCall(date){
      console.log(date)
      let format = this.fixDate(date, 'yyyy-MM-dd')
      let payload = {
          start : format
      }
      if(this.popSelect){
        payload['state'] = this.popSelect
      }
      this.loadingShow()
      this.$store.dispatch('GET_CALENDAR_DAY', payload)
      .then(result =>{
          this.loadingHide()
          this.calendarDayOptions.events = []
          result.forEach((album,index) => {
              const event = {}
              event.id = index 
              event.start = album.date
              event.extendedProps = {}
              event.extendedProps.data = album
              event.extendedProps.title = 'ddd'
              this.calendarDayOptions.events.push(event)
          })
      }).catch(error=>{
          this.loadingHide()
          
      })
    },
    queryEvents (type, date) {
      
    },
    createEvents (dataList) {
      this.calendarOptions.events = []
      dataList.forEach((album,index) => {
        const event = {}
        event.id = index 
        event.title = 'asdasdasdas' 
        event.start = album.date
        event.extendedProps = {}
        event.extendedProps.data = album
        event.extendedProps.title = 'ddd'
        this.calendarOptions.events.push(event)
      })
    },
     
    gotoDate (date) {
      const targetDate = new Date(date)
      const calendarApi = this.$refs.fullCalendar.getApi()
      calendarApi.gotoDate(targetDate)
      const currentStart = calendarApi.view.currentStart
      this.checkBaseDay(currentStart)
    }, 
    dateCall(date){
      const calendarApi = this.$refs.fullCalendar.getApi()
      console.log(calendarApi.view)
      const currentStart = calendarApi.view.activeStart
      let format = this.fixDate(currentStart, 'yyyy-MM-dd')
      let payload = {
          start : format
      }
      let url = 'dayGridMonth'
      if(calendarApi.view.type == 'dayGridMonth'){
        
        if(this.monthType == 'A'){
          url = 'GET_CALENDAR_MONTH'
        }else{
          url = 'GET_CALENDAR_MONTH_ALBUM'
        }
        
      }else  if(calendarApi.view.type == 'dayGridWeek'){
        url = 'GET_CALENDAR_WEEK'
      }else{
        url = 'GET_CALENDAR_DAY'
      }
      if(this.tags_v2.length > 0){
        payload['tags_v2'] = this.tags_v2
      }
      this.loadingShow()
      this.$store.dispatch(url, payload)
      .then(result =>{
          this.loadingHide()
          this.calendarOptions.events = []
          result.forEach((album,index) => {
              const event = {}
              event.id = index 
              event.start = album.date
              event.extendedProps = {}
              event.extendedProps.data = album
              event.extendedProps.title = 'ddd'
              this.calendarOptions.events.push(event)
          })
      }).catch(error=>{
          this.loadingHide()
          
      })
    },
    slotChange(){
      this.slotEdit = !this.slotEdit; 
      if(this.slotEdit){
        this.slotCall()
      }
    },
    slotCall(date){
      const calendarApi = this.$refs.fullCalendarSlot .getApi()
      const currentStart = calendarApi.view.activeStart
      let format = this.fixDate(currentStart, 'yyyy-MM-dd')
      let payload = {
          start : format
      }
      let url = 'dayGridMonth'
      if(calendarApi.view.type == 'dayGridMonth'){
        url = 'GET_CALENDAR_MONTH'
      }else  if(calendarApi.view.type == 'dayGridWeek'){
        url = 'GET_CALENDAR_WEEK'
      }else{
        url = 'GET_CALENDAR_DAY'
      }
      this.loadingShow()
      this.$store.dispatch(url, payload)
      .then(result =>{
          this.loadingHide()
          console.log(result);
          this.slotCalendarOptions.events = []
          result.forEach((album,index) => {
              const event = {}
              event.id = index 
              event.start = album.date
              event.extendedProps = {}
              event.extendedProps.data = album
              event.extendedProps.title = 'ddd'
              this.slotCalendarOptions.events.push(event)
          })
      }).catch(error=>{
          this.loadingHide()
          
      })
    },

    dayCall(date){
      let format = this.fixDate(date, 'yyyy-MM-dd')
      let payload = {
          start : format
      }
      if(this.popSelect){

      }
      this.loadingShow()
      this.$store.dispatch('GET_CALENDAR_DAY', payload)
      .then(result =>{
          this.loadingHide()
          this.calendarDayOptions.events = []
          result.forEach((album,index) => {
              const event = {}
              event.id = index 
              event.start = album.date
              event.extendedProps = {}
              event.extendedProps.data = album
              event.extendedProps.title = 'ddd'
              this.calendarDayOptions.events.push(event)
          })
      }).catch(error=>{
          this.loadingHide()
          
      })
    },
    daySet(date){
        console.log(date)
        const calendarApi = this.$refs.fullCalendar.getApi()
        calendarApi.gotoDate(date)
        this.dateCall(date)
    },
    slotSave(){
      let payload ={
        params :[]
          
      }
      const calendarApi = this.$refs.fullCalendarSlot.getApi()
      let event = calendarApi.getEvents()
      
      let array = []
      for(let i in event ){
        array.push (
          {
            date : event[i]._def.extendedProps.data.date ,
            slots : event[i]._def.extendedProps.data.count_slots
          }
        )
      }
      payload.params = array
      this.loadingShow()
      this.$store.dispatch('PUT_SLOT_MONTH', payload)
      .then(result =>{
          this.loadingHide()
          
          
      }).catch(error=>{
          this.loadingHide()
          
      })

    },
    openEditSlot(data){
      this.daySlotData = {...data}
      this.openModal('daySlot')
    },
    saveDaySlot(){
      let payload ={
        params :
          { 
            date : this.daySlotData.date,
            slots : this.daySlotData.count_slots
          }
      }
      this.loadingShow()
      this.$store.dispatch('PUT_SLOT_DAY', payload)
      .then(result =>{
          console.log(result)
          this.loadingHide()
          this.dateCall('dd')
          this.closeModal('daySlot')
          
      }).catch(error=>{
          this.loadingHide()
          
      })
    },
  },
  watch: {
    tags_v2(){
      this.dateCall()
    },
    slotEdit(val){
      if(val){
        
        
        
      }else{
        
      }
    },
    
  },
}
</script>
